import { render } from "./BusinessSwitcher.vue?vue&type=template&id=5aa27014&scoped=true"
import script from "./BusinessSwitcher.vue?vue&type=script&lang=js"
export * from "./BusinessSwitcher.vue?vue&type=script&lang=js"

import "./BusinessSwitcher.vue?vue&type=style&index=0&id=5aa27014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa27014"]])

export default __exports__